import { Container, Title, Text, Box, ThemeIcon, Stack, Paper, SimpleGrid, Badge } from "@mantine/core";
import { IconFileText, IconShieldCheck, IconUsers, IconChevronRight } from "@tabler/icons-react";

export default function HowItWorksSection() {
  return (
    <Container size="lg" py={120}>
      <Stack gap="xl" align="center" mb={60}>
        <Title order={2} style={{ fontSize: "2.5rem", fontWeight: 700, color: "#1a202c" }}>
          How GT Setu Works
        </Title>
        <Text c="slate.6" size="lg" ta="center" maw={600}>
          A simple, secure process to connect with verified business partners worldwide
        </Text>
      </Stack>

      <SimpleGrid cols={{ base: 1, md: 3 }} spacing={60} style={{ position: "relative" }}>
        {/* Step 1 */}
        <Paper p="xl" radius="lg" bg="slate.0" style={{ position: "relative", overflow: "visible" }}>
          <Stack align="center" gap="lg">
            <Box style={{ position: "relative" }}>
              <ThemeIcon size={64} radius={64} color="primary" variant="light">
                <IconFileText size={28} />
              </ThemeIcon>
              <Badge
                size="md"
                circle
                color="primary"
                style={{
                  position: "absolute",
                  top: -5,
                  right: -5,
                  width: 30,
                  height: 30,
                  padding: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "3px solid white",
                  borderRadius: "50%",
                }}
              >
                1
              </Badge>
            </Box>
            <Text fw={700} size="xl" mt="sm">
              Register & Get Verified
            </Text>
            <Text c="slate.6" ta="center" size="sm" lh={1.6}>
              Sign up and complete verification to build trust and access the platform.
            </Text>
          </Stack>
          {/* Arrow for Desktop */}
          <Box
            style={{ position: "absolute", top: "50%", right: -50, zIndex: 10, transform: "translateY(-50%)" }}
            visibleFrom="md"
          >
            <IconChevronRight size={32} color="#E2E8F0" />
          </Box>
        </Paper>

        {/* Step 2 */}
        <Paper p="xl" radius="lg" bg="slate.0" style={{ position: "relative", overflow: "visible" }}>
          <Stack align="center" gap="lg">
            <Box style={{ position: "relative" }}>
              <ThemeIcon size={64} radius={64} color="primary" variant="light">
                <IconShieldCheck size={40} />
              </ThemeIcon>
              <Badge
                size="md"
                circle
                color="primary"
                style={{
                  position: "absolute",
                  top: -5,
                  right: -5,
                  width: 30,
                  height: 30,
                  padding: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "3px solid white",
                  borderRadius: "50%",
                }}
              >
                2
              </Badge>
            </Box>
            <Text fw={700} size="xl" mt="sm">
              Discover & Collaborate
            </Text>
            <Text c="slate.6" ta="center" size="sm" lh={1.6}>
              Discover verified companies, relevant opportunities, and connect with partners that match your business
              goals.
            </Text>
          </Stack>
          {/* Arrow for Desktop */}
          <Box
            style={{ position: "absolute", top: "50%", right: -50, zIndex: 10, transform: "translateY(-50%)" }}
            visibleFrom="md"
          >
            <IconChevronRight size={32} color="#E2E8F0" />
          </Box>
        </Paper>

        {/* Step 3 */}
        <Paper p="xl" radius="lg" bg="slate.0">
          <Stack align="center" gap="lg">
            <Box style={{ position: "relative" }}>
              <ThemeIcon size={64} radius={64} color="primary" variant="light">
                <IconUsers size={40} />
              </ThemeIcon>
              <Badge
                size="md"
                circle
                color="primary"
                style={{
                  position: "absolute",
                  top: -5,
                  right: -5,
                  width: 30,
                  height: 30,
                  padding: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "3px solid white",
                  borderRadius: "50%",
                }}
              >
                3
              </Badge>
            </Box>
            <Text fw={700} size="xl" mt="sm">
              Initiate & Lead
            </Text>
            <Text c="slate.6" ta="center" size="sm" lh={1.6}>
              Initiate conversations, collaborate confidently, and convert connections into qualified business leads.
            </Text>
          </Stack>
        </Paper>
      </SimpleGrid>
    </Container>
  );
}
